//
import EmployeeModel from '@/models/HumanResource/HrEmployee'
import FiniquitoStatusModel from '@/models/HumanResource/HrFiniquitoStatus'
import UserModel from '@/models/General/GUser'

// hr_employee_id, hr_contract_id, hr_causal_id, g_user_id, g_authorizer_user_id, hr_finiquito_status_id
export default [
    {
        name: 'hr_employee_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'name_case',
            itemValue: 'id',
            label: 'Empleado',
            model: EmployeeModel,
            noObject: true,
            paramSearch: 'names',
        },
    },
    {
        name: 'g_user_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'hr_employee_full_name',
            itemValue: 'id',
            label: 'Encargado',
            model: UserModel,
            noObject: true,
        },
    },
    {
        name: 'g_authorizer_user_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'hr_employee_full_name',
            itemValue: 'id',
            label: 'Supervisor',
            model: UserModel,
            noObject: true,
        },
    },
    {
        name: 'hr_finiquito_status_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'status',
            itemValue: 'id',
            label: 'Estado',
            model: FiniquitoStatusModel,
            noObject: true,
            paramSearch: 'name',
        },
    },
]
